/* Florema · tarjeta de producto editorial (snippet florema-card-editorial) · oct 2026
   Lo que comparten TODAS las tarjetas, estén donde estén (portada, colecciones, relacionados de la ficha, páginas Cyber, búsqueda):
   1) agregar al carro real: vuela la foto, agrega, "✓ Agregado" y abre el carro lateral del tema;
   2) apagado del texto "CYBER" de las insignias (y del chip de precio de la ficha) al terminar el Cyber (misma fecha que el ajuste del tema, o ?fin=1).
   Se puede cargar varias veces: solo se inicia una. */
(function () {
  'use strict';
  if (window.__flkCard) return;
  window.__flkCard = true;

  var doc = document, html = doc.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- 1. Cyber: fecha de término ---------- */
  function parseEnd(s) {
    s = String(s || '').replace(/^\s+|\s+$/g, '');
    if (!s) return NaN;
    // "2026-10-11 23:59" (hora de Chile, UTC−3) → "2026-10-11T23:59:00-03:00"
    var m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?\s*(Z|[+-]\d{2}:?\d{2})?$/);
    if (!m) return Date.parse(s);
    var hh = m[2].length === 1 ? '0' + m[2] : m[2];
    var tz = m[5] ? (m[5] === 'Z' ? 'Z' : m[5].replace(/^([+-]\d{2})(\d{2})$/, '$1:$2')) : '-03:00';
    return Date.parse(m[1] + 'T' + hh + ':' + m[3] + ':' + (m[4] || '00') + tz);
  }
  function cyber() {
    var el = doc.querySelector('.flk-cyo[data-end]');
    var END = el ? parseEnd(el.getAttribute('data-end')) : NaN;
    if (!(END > 0)) { var cb = doc.querySelector('[data-florema-cyber-bar][data-end]'); if (cb) END = parseEnd(cb.getAttribute('data-end')); }
    if (/[?&]fin=1(&|$)/.test(location.search) || (END > 0 && END <= Date.now())) fin();
    else if (END > 0 && END - Date.now() < 2147000000) setTimeout(fin, END - Date.now() + 500);
  }
  /* termina el Cyber: las tarjetas lo hacen por CSS (.flk-fin); el chip de precio de la ficha viene en el HTML como "CYBER −20%", se le saca la palabra */
  function chipFicha() {
    [].forEach.call(doc.querySelectorAll('.florema-pdp__price-discount'), function (c) {
      var t = c.textContent;
      if (/^\s*CYBER\s/i.test(t)) c.textContent = t.replace(/^\s*CYBER\s+/i, '');
    });
  }
  function fin() {
    html.classList.add('flk-fin');
    chipFicha(); setTimeout(chipFicha, 1500);   // otra pasada por si otro script reescribe el chip
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', cyber); else cyber();

  /* ---------- 2. agregar al carro (real) ---------- */
  function agregar(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-flk-add]');
    if (!b || e.defaultPrevented) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled || b.classList.contains('is-ok')) return;
    var id = parseInt(b.getAttribute('data-flk-add'), 10); if (!id) return;
    var card = b.closest('.flk-card'), img = card && card.querySelector('.flk-ph-a img');
    var lbl = b.querySelector('.flk-lbl'), orig = lbl ? lbl.textContent : '';
    var vuela = false;
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    if (window.FloremaFly && img) { try { window.FloremaFly(img, b); vuela = !reduce; } catch (err) {} }
    agregar(id).then(function () {
      b.classList.add('is-ok'); if (lbl) lbl.textContent = '✓ Agregado';
      var C = window.FloremaCart;
      if (C) {
        if (typeof C.refresh === 'function') { try { C.refresh(); } catch (err) {} }
        if (typeof C.open === 'function') setTimeout(function () { try { C.open(); } catch (err) {} }, vuela ? 850 : 0);
      }
    }).catch(function () {
      b.classList.add('is-err'); if (lbl) lbl.textContent = 'Sin stock';
    }).then(function () {
      b.removeAttribute('aria-busy');
      setTimeout(function () { b.classList.remove('is-ok', 'is-err'); if (lbl) lbl.textContent = orig; b.disabled = false; }, 1700);
    });
  });
})();
